/**
 * ドロップダウンメニュー制御処理を行う
 */
$(function(){
    // 検索テキストボックスでのキーダウンイベント処理
    $(document).on('keydown', '.dropdown-searchbox input', function(e){
        switch (e.key) {
            case 9: // Tab
                e.preventDefault();
                e.stopPropagation();
                // that.$menuInner.click();
                // that.$button.focus();
                break;
            case 13: // Enter
                dropdownSelectItem(e, $(this));
                break;
            case 27: // Esc
                e.preventDefault();
                e.stopPropagation();
                // that.$button.focus();
                // that.previouslySelected && that.setSelected(that.previouslySelected);
                // that.$button.dropdown('toggle');
                break;
            case 38: // Up
                e.preventDefault();
                // that.moveUp();
                break;
            case 40: // Down
                e.preventDefault();
                // that.moveDown();
                break;
            default:
                break;
        }
    });
    // 検索テキストボックス変更時処理
    $(document).on('input propertychange', '.dropdown-searchbox input', function(e){
        dropdownSelectItem(e, $(this));
    });
    // ドロップダウン項目絞り込み
    function dropdownSelectItem(e, searchbox)
    {
        e.preventDefault();
        var searchString = $(searchbox).val().toLowerCase();
        var items = $(searchbox).parent().parent().find('.dropdown-item');
        if (searchString.length === 0) {
            items.each(function() {
                var item = $(this);
                item.toggleClass('disabled', false);
                item.toggleClass('d-none', false);
            });
        } else {
            items.each(function() {
                var item = $(this);
                var text = item.text().toLowerCase();
                if (text.indexOf(searchString) !== -1) {
                    item.toggleClass('disabled', false);
                    item.toggleClass('d-none', false);
                    // if (that.options.hierarchy) {
                    //     disableParents(item);
                    // }
                } else {
                    item.toggleClass('disabled', false);
                    item.toggleClass('d-none', true);
                }
            });
        }
    }
    function disableParents(element) {
        var item = element;
        var level = item.data('level');
        while (typeof item === 'object' && item.length > 0 && level > 1) {
            level--;
            item = item.prevAll('a[data-level="' + level + '"]:first');
            if (item.hasClass('d-none')) {
                item.toggleClass('disabled', true);
                item.removeClass('d-none');
            }
        }
    }
})